import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { Small, H1, H3 } from '@dbk/ui-text';
import { EditCircle, Priority } from '@dbk/ui-icons';
import { FormattedMessage } from '@dbk-legacy/format';
import { WarningDarkIcon } from '../../../components/common/icons';
import debounce from 'lodash/debounce';
import {
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemFooter,
} from '@dbk/ui-list';
import { FormattedNumber } from '@dbk/format';
import { ShortDate } from '@dbk/ui-dates';
import { Checkbox, TextInput } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import Toggle from '@dbk/ui-toggle';
import PymtDetails from './payment-details/payment-details';
import PymtAmtDetails from './payment-amount-details/payment-amount-details';
import { LoadingCircle } from '../../../components/common/loading';
import PaymentError from '../payment-error';
import FormBackConfirmModal from '../../../components/common/form-back-confirm-modal'
import styles from './payment-form.styles';
import { EBANKINGWEBLUX, RM_REGION_UK, ROUTES, SEPA_PAYMENT_TYPE } from '../../../constants'
import { PALETTE, WARNING_ICON,EBANKINGWEBUK, KEY_CODE, EVENT_TYPE, IS_BANK_SEPA_PARTICIPANT } from '../../../constants';
import { isEqual } from 'lodash';
import { getInstantSepaAmountValidation, getModifiedTemplateObject, getSelectedTemplate } from '../payment-utils';
import Modal from '@dbk/ui-modal';
import { InfoDarkIcon, SuccessDarkIcon, WarningIcon } from '../../../components/common/icons';
import {validateBenefName, isEmpty} from '../../payments/payment-destination/utils';
import envConfig from '../../../../db-env-build';
import labelForPFid from '../../../utils/portfolio-number-aria-label';
import { View as DbkView } from '@dbk/ui-react-utils';
import Popover from '@dbk/ui-popover';
import { Info2 } from '@dbk/ui-icons';
 
const {
  DESTINATION,
  TX_SUMMARY,
  DEBIT_ACCOUNT_LIST,
  ADD_BENEFICIARY
} = ROUTES.PAYMENT
 
const alignRightStyle = { flex: 1, alignItems: 'flex-end' };
const footerTextContainerStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  flex: 1,
  flexWrap: 'wrap',
  width: '100%',
  maxWidth: '100%',
  whiteSpace: 'normal',
};
const footerLabelStyle = {
  color: PALETTE.secondaryText,
  display: 'inline',
  flex: '0 0 auto',
  marginRight: 4,
  width: 'auto',
  maxWidth: 'none',
  whiteSpace: 'nowrap',
};
const footerValueStyle = {
  color: PALETTE.secondaryActive,
  display: 'inline',
  flex: '1 1 0%',
  minWidth: 0,
  width: 'auto',
  maxWidth: '100%',
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
};
const detailFooterStyle = {
  width: '100%',
  maxWidth: '100%',
  overflow: 'visible',
};

const getBeneficiaryName = (firstName, lastName) => {
  return (firstName || '') + (firstName && lastName ? ' ' : '') + (lastName || '')
}
 
const defaultValue = { accBalance: null, accName: null, currency: null, accNo: null, asOfDate: null, bpName: null }
const getBalance = balance => typeof balance === 'string' ?
  Number(balance.replace(/,/g, '')) : balance
 
class PaymentForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentTemplateName: this.props.payments.templateName,
      warnModifiedTemplate: false
    }
  }
 
  componentDidMount(){
    this.props.payments.setSaveModifiedTemplate(false);
    this.props.payments.setBeneficiaryIdToUpdate(null);
    this.props.payments.setExistingBeneficiaryId(null);
  }

  componentDidUpdate(){
    if(document.querySelector('button.proceed')){
      document.querySelector('button.proceed').focus();
    }
    if(document.querySelector('.warningPaymentTemplate')){
      document.querySelector('.warningPaymentTemplate').focus();
    }
  }
  
  onValidateClick = () => {
    const {
      payments: { isPaymentTemplateFlow, isSaveEnabled }
    } = this.props;
    if (isPaymentTemplateFlow) {
      const {
        payments: { setTemplateName, selectedPaymentTemplate, amount, paymentReason, selectedBeneficiaryBank, selectedDebitAcnt, selectedCreditAcnt, selectedCurrency, selectedCost }
      } = this.props;

      let { payments: { remarks } }= this.props;

      const {
        currentTemplateName
      } = this.state;
      if(isSaveEnabled){
        setTemplateName(currentTemplateName);
      }else{
        setTemplateName(selectedPaymentTemplate.templateName);
      }
      const toNumber = amt =>
        typeof amt === 'number' ? amt : Number(amt.replace(/[^0-9.]/g, ''))
 
      if (selectedPaymentTemplate) {
 
        const paymentModifiedTemp = getModifiedTemplateObject(({
          amount: toNumber(amount),
          remarks: remarks==='' ? null : remarks,
          from: selectedDebitAcnt,
          to: selectedBeneficiaryBank || selectedCreditAcnt,
          currency: selectedCurrency,
          cost: selectedCost,
          templateName: currentTemplateName
        }))
        const selectedPaymentTemp = getSelectedTemplate(selectedPaymentTemplate);
        // if checkbox is enabled dont show the warning confirmation save message
        if (!isEqual(selectedPaymentTemp, paymentModifiedTemp) && !isSaveEnabled) {
          this.setState({ warnModifiedTemplate: true });
          return;
        }
      }
    }
    this.props.payments.validatePayment();
    // todo: route depends on dwoMessages
    this.props.changePage(TX_SUMMARY);
  }
 
  selectBeneficiary = async (e) => {
    const {
      changePage,
      payments: { paymentType, loadCreditAccountList,  isModifyFlow }
    } = this.props;
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      // if((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes('domestic') && isModifyFlow){ //WMCE-39640 +WMCE-38994
      //   return;
      // }
      await this.props.payments.setDebitAccountFlow(false);
      if (paymentType.includes('internal')) loadCreditAccountList()
      else changePage(DESTINATION);
    }
  }
 
  renderSelfAccount = (data1, messages) => {
    const data = data1 != null ? data1 : defaultValue;
    const balance = data != null ? getBalance(data.accBalance) : null;
    const accountText = messages['app.common.portfolio.bonds.account'];
    const accountNameText = messages['app.payment.account.name'];
    const ibanText = messages['app.payment.psd2.ibanNo'];
    const portfolioText = messages['app.payments.portfolio.text'];
    return (
      <React.Fragment>
        <NavigationListItemFooter
          tabIndex={data.bpName ? 0 : -1}
          color={PALETTE.secondaryActive}
          aria-label={data.bpName ? data.bpName : labelForPFid(data.accNo)}
          style={detailFooterStyle}>
          <Text plain style={footerTextContainerStyle}>
            <Text plain style={footerLabelStyle}>{`${accountText}:`}</Text>
            <Text plain style={footerValueStyle}>{data.bpName}</Text>
          </Text>
           <View style={alignRightStyle} tabIndex={0}>
            {balance &&
              <Text size="small">
                <FormattedNumber
                  // color={PALETTE.secondaryActive}
                  renderProps={{ style: { color: PALETTE.secondaryActive } }}
                  value={balance}
                  style="currency"
                  currencyDisplay="code"
                  currency={data.currency}
                />
              </Text>}
          </View>
        </NavigationListItemFooter>
        <NavigationListItemFooter
          tabIndex={data.accName ? 0 : -1}
          color={PALETTE.secondaryActive}
          style={detailFooterStyle}>
          <Text plain style={footerTextContainerStyle}>
            <Text plain style={footerLabelStyle}>{`${accountNameText}:`}</Text>
            <Text plain style={footerValueStyle}>{data.accName}</Text>
          </Text>
          <View style={alignRightStyle}>
            <Small size="small" >
             { (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) ?
              <Text>{messages['app.payment.asOfToday']}</Text>  
            :
              <Text plain style={footerTextContainerStyle}>
                <Text plain style={footerLabelStyle}>{messages['app.payments.asOfDate']}</Text>
                <Text plain style={footerValueStyle}>{                      
                  <ShortDate value={new Date(data.asOfDate)}/>
              }</Text>
              </Text>}
            </Small>
          </View>
        </NavigationListItemFooter>
        <NavigationListItemFooter
          tabIndex={data.ibanNo ? 0 : -1}
          style={data.ibanNo ? detailFooterStyle : [detailFooterStyle, { display: 'none' }]}>
          <Text plain style={footerTextContainerStyle}>
            <Text plain style={footerLabelStyle}>{`${ibanText}:`}</Text>
            <Text plain style={footerValueStyle}>{data.ibanNo}</Text>
          </Text>
        </NavigationListItemFooter>
        <NavigationListItemFooter tabIndex={data.pfId ? 0 : -1} aria-label={portfolioText + ' ' + labelForPFid(data.pfId)} style={detailFooterStyle}>
          <Text plain style={footerTextContainerStyle}>
            <Text plain style={footerLabelStyle}>{`${portfolioText}:`}</Text>
            <Text plain style={footerValueStyle}>{data.pfId}</Text>
          </Text>
        </NavigationListItemFooter>
      </React.Fragment>
    )
  }
 
  navigateToSelectDebit = async(isInternal, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      await this.props.payments.setDebitAccountFlow(true);
      this.props.payments.setModifyDebitAcntFlag(true);
      if (isInternal)
        this.props.payments.loadDebitAccountList();
      else
        this.props.changePage(DEBIT_ACCOUNT_LIST);
  
      this.props.payments.setIsPymtAddNewBenef(false);
    }
  }
 
  confirmFormBackConfirm = () => {
    const {payments: { isCashFlow, isModifyFlow, setDisableTabs,isCashPaymentFlow }} = this.props;
      if(isCashFlow  &&  !isModifyFlow){ 
        setDisableTabs(false);
        if(isCashPaymentFlow){   //WMCE-47749- To switch over cash account tab
        this.props.payments.setIsCashPaymentFlow(false);
        this.props.changePage(ROUTES.CASH_ACCOUNTS.SUMMARY_CASH_ACCOUNTS_ROUTE); 
        }
        else{
        this.props.portfolio.setAssetClassName('liquidity');
        this.props.changePage(ROUTES.PORTFOLIO.DASHBOARD, true);
        this.props.changePage(ROUTES.PORTFOLIO.GENERIC_ASSETS);
        }
      }else{
        this.props.changePage(ROUTES.PAYMENT.DASHBOARD)
      }
  }
 
  renderFromAccount = (selectedDebitAcnt, messages, isInternal) => (
    <NavigationListItem 
     style={{ borderColor: PALETTE.primaryActive }} className="full-height ben-to-container ben-to-container--center-arrow" inverse hasArrow={true} onKeyDown={(e) => this.navigateToSelectDebit(isInternal, e)}  onClick={() => this.navigateToSelectDebit(isInternal)} tabIndex={-1}>
      <NavigationListItemHeader className={"ben-to-header-container paddingTop0"} color={PALETTE.primaryText} tabIndex={0}>
        <Text className={"ben-to-header"}>{messages['app.payments.destination.from']}</Text>
      </NavigationListItemHeader>
      {selectedDebitAcnt != null ? this.renderSelfAccount(selectedDebitAcnt, messages) :
        <NavigationListItemFooter color={PALETTE.secondaryActive} tabIndex={0}>{messages['app.payment.pageTitle.debitAccount']}</NavigationListItemFooter>}
    </NavigationListItem>
  )
 
  renderToAccount = (account, messages, isInternal, paymentType) => {
    let content;
    const {
      auth: {addBeneficiaryDisabled}} = this.props;
    if (!account) {
      // render placeholder when no account selected
      const msg = isInternal ?
        messages['app.payments.selectCreditAcc'] :
        messages['app.payment.pageTitle.selectBeneficiary']
      content = <NavigationListItemFooter tabIndex={0}><Text primary >{msg}</Text></NavigationListItemFooter>
    } else if (isInternal) {
      // internal
      content = this.renderSelfAccount(account, messages)
    } else {
      // non-internal
      const {
        beneficiaryName,
        firstName,
        lastName,
        accountNo,
        ibanNo,
        bank,
        swiftCode = '',
        ntnlId,
        address1,
        address2,
        address3,
        city,
        cityName,
        postalCode,
        country, 
        sortCode
      } = account;
      let swiftOrNtnlId = bank + (swiftCode?(' ('+swiftCode+')'):'')
      let swiftOrNtnlIdLabel = bank + " "+(swiftCode ? swiftCode.split('').join(' ') : '')
      if(paymentType.includes('domestic')){
        swiftOrNtnlId = bank + (ntnlId?(' ('+ntnlId+')'):'')
        swiftOrNtnlIdLabel = bank +  " "+(ntnlId ? ntnlId.split('').join(' ') : '')
      }
      let sortCodeFormat;
      if(sortCode) {
        if(sortCode.length === 6) {
          sortCodeFormat = `${sortCode.slice(0,2)}-${sortCode.slice(2,4)}-${sortCode.slice(4,6)}`;
        }
        if(sortCode.length === 8) {
          sortCodeFormat = sortCode;
        }
      }

      const bankSwift = swiftOrNtnlId
      const beneficiaryDisplayName = beneficiaryName || getBeneficiaryName(firstName, lastName)
      const accountDisplayValue = accountNo || ibanNo
      const bankDisplayValue = envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic') ?
        [bank, sortCodeFormat].filter(Boolean).join(' ') : bankSwift
      const locationDisplayValue = [city || cityName, country].filter(Boolean).join(', ')

      content = (
        <DbkView>
          <React.Fragment>
            <NavigationListItemFooter tabIndex={beneficiaryDisplayName ? "0" : "-1"} className="ben-name-text" style={detailFooterStyle}>
              <Text plain style={footerTextContainerStyle}>
                <Text plain style={footerLabelStyle}>{`${messages['app.manageContactDetails.addContact.name']}: `}</Text>
                <Text plain style={footerValueStyle}>{beneficiaryDisplayName}</Text>
              </Text>
            </NavigationListItemFooter>
            <NavigationListItemFooter tabIndex={accountDisplayValue ? 0 : -1} style={detailFooterStyle}>
              <Text plain style={footerTextContainerStyle}>
                <Text plain style={footerLabelStyle}>{`${messages['app.incomehistory.accNum']} `}</Text>
                <Text plain style={footerValueStyle}>{accountDisplayValue}</Text>
              </Text>
            </NavigationListItemFooter>
            <NavigationListItemFooter tabIndex={bankDisplayValue ? 0 : -1} aria-label={swiftOrNtnlIdLabel} style={detailFooterStyle}>
              <Text plain style={footerTextContainerStyle}>
                <Text plain style={footerLabelStyle}>{`${messages['app.payments.summary.bank']}: `}</Text>
                <Text plain style={footerValueStyle}>{bankDisplayValue}</Text>
              </Text>
            </NavigationListItemFooter>
            <NavigationListItemFooter tabIndex={locationDisplayValue ? 0 : -1} style={detailFooterStyle}>
              <Text plain style={footerTextContainerStyle}>
                <Text plain style={footerValueStyle}>{locationDisplayValue}</Text>
              </Text>
            </NavigationListItemFooter>
          </React.Fragment>
        </DbkView>
      )
    }
    return (
 
      <NavigationListItem
        tabIndex={-1}
        testID="list_paymentTo_paymentForm_test"
        className="full-height ben-to-container"
        inverse
        role="link"
        hasArrow={false}
        style={{ borderColor: PALETTE.primaryActive }}
        onKeyDown={(e) => this.selectBeneficiary(e)}
        onClick={() => this.selectBeneficiary()}>
        <NavigationListItemHeader className={"ben-to-header-container"} tabIndex={0}><Text className={"ben-to-header"}>{messages['app.payments.destination.to']}</Text></NavigationListItemHeader>
 
        {content}
        {!isInternal ? 
          <div role ="button" tabIndex={0} aria-label={messages['app.payment.editButton']} 
            className={addBeneficiaryDisabled?"payment-edit-button edit-disabled":"payment-edit-button"}
            onKeyDown={!addBeneficiaryDisabled?(event) => this.editBeneficiary(event, account):(event)=> {event.stopPropagation()} } 
            onClick={!addBeneficiaryDisabled?(event) => this.editBeneficiary(event, account): (event)=> {event.stopPropagation()}}
          >
            <EditCircle width={26} height={26} color={PALETTE.secondaryActive}/>
          </div> : <div></div>
        }
       
      </NavigationListItem>
 

    )
  }
 
  editBeneficiary = async (event, item) => {
    const {
      payments: { setSelectedBeneficiaryBank, setIBAN, setSelectedBeneficiaryDetail, paymentType },
    } = this.props
    if( event && (event.keyCode || event.type) && (event.keyCode === KEY_CODE.ENTER_KEY || event.keyCode === KEY_CODE.SPACE_KEY || event.type.toLowerCase() === EVENT_TYPE.CLICK) ){
      event.stopPropagation();
      this.props.payments.setPaymentEditCapture(item ? true: false); //WMCE-39640 when payment initiate from cash account item will be null.
      item && item.ibanNo ? setIBAN(true) : setIBAN(false);
      if(item === null && (paymentType.includes('international') || paymentType.includes('sepa'))){
        setIBAN(true); //WMCE-40703 UK Web and App- Edit button new beneficiary screen should by default to iban flow
      }

      setSelectedBeneficiaryBank(item);
      setSelectedBeneficiaryDetail(item);

      this.props.changePage(ADD_BENEFICIARY);
    }
  }
 
  handleCheck = async () => {
    const { payments: { setTemplateName, isPaymentTemplateFlow, selectedPaymentTemplate } } = this.props;
    await this.props.payments.toggleSave(!this.props.payments.isSaveEnabled);
    const isEnabled = !this.props.payments.isSaveEnabled;
    if(isEnabled){
      if(isPaymentTemplateFlow){
        this.setState({ currentTemplateName: selectedPaymentTemplate.templateName });
      }else {
        this.setState({ currentTemplateName: "" });
        setTemplateName(null);
     }
    }
  }
 
  handleTemplateName = (event) => {
    const { payments: { setTemplateName } } = this.props;
    this.setState({ currentTemplateName: event.target.value });
    setTemplateName(event.target.value);
  }

  getSEPAIPStatusMsg = () => {
    const { payments: { selectedBeneficiaryBank }, i18n: { messages } } = this.props;
    const isBankSepaIpParticipant = selectedBeneficiaryBank && selectedBeneficiaryBank.isBankSepaIpParticipant;
    let statusText = this.props.payments.selectedBeneficiaryBankSEPAPaymentType === SEPA_PAYMENT_TYPE.INSTANT
      ? messages['app.payments.sepaip.status.on']
      : messages['app.payments.sepaip.status.off'];
    if(isBankSepaIpParticipant === IS_BANK_SEPA_PARTICIPANT.YES){
      return <div className='payment-sepaip-status-container payment-sepaip-status-container--participant'>
        <span className='margin-top-3'> <InfoDarkIcon height={18} width={18} color={PALETTE.touchableOpacityEnable} /></span>
        <span className='payment-sepaip-status' tabIndex={0}>
          <FormattedMessage
                      id={`app.payments.sepaip.participant`}
                      values={{
                        status: statusText
                      }}
                    ></FormattedMessage>
          </span>
        </div>
    } else if(isBankSepaIpParticipant === IS_BANK_SEPA_PARTICIPANT.NO){
      return <div className='payment-sepaip-status-container payment-sepaip-status-container--non-participant'>
        <span><WarningDarkIcon height={16} width={16} color= {PALETTE.primaryNegative}></WarningDarkIcon></span>
        <span className='pad-left-5' tabIndex={0}>{messages['app.payments.sepaip.nonParticipant']}</span>
        </div>
    }
    return null;
  }

  onSepaIpCheckBoxToggle = (checked) => {
    const nextChecked = typeof checked === 'boolean'
      ? checked
      : this.props.payments.selectedBeneficiaryBankSEPAPaymentType !== SEPA_PAYMENT_TYPE.INSTANT;
    const nextType = nextChecked ? SEPA_PAYMENT_TYPE.INSTANT : SEPA_PAYMENT_TYPE.CLASSIC;
    if (this.props.payments.selectedBeneficiaryBankSEPAPaymentType === nextType) return;
    this.props.payments.setSelectedBeneficiaryBankSEPAPaymentType(nextType);
  }
 
  renderSepaIPUI = () => {
    const { payments: { selectedBeneficiaryBank, selectedBeneficiaryBankSEPAPaymentType }, i18n: { messages } } = this.props;
    const isBankSepaIpParticipant = selectedBeneficiaryBank && selectedBeneficiaryBank.isBankSepaIpParticipant;
    return (
      <div
        className='payment-sepaip-toggle-row'
        aria-label="Notification toggle">
          <Toggle className='mr-10' 
          checked = {selectedBeneficiaryBankSEPAPaymentType === SEPA_PAYMENT_TYPE.INSTANT}
          disabled={isBankSepaIpParticipant === IS_BANK_SEPA_PARTICIPANT.NO}
          label={messages['app.payments.summary.instantPayment']}
          //   disabled={!item.emailId || item.action === "DELETE" || item.isDeleted } 
          // checked={item.ealerts === PAPERLESS_OPT_IN_STATUS.EALERT_YES ? true : false}
          onChange={(checked) => this.onSepaIpCheckBoxToggle(checked)}
          />
          {selectedBeneficiaryBankSEPAPaymentType === SEPA_PAYMENT_TYPE.CLASSIC && <span className='margin-right-40 margin-left-8'><WarningDarkIcon height={24} width={24} color= {isBankSepaIpParticipant === IS_BANK_SEPA_PARTICIPANT.NO ? PALETTE.primaryNegative : PALETTE.warning}></WarningDarkIcon></span>}
          {selectedBeneficiaryBankSEPAPaymentType === SEPA_PAYMENT_TYPE.INSTANT && <span className='margin-right-40 margin-left-8'><SuccessDarkIcon/></span>}
          {<Popover
            mode="popup"
            orientation="top"
            showOnHover
            popOverClassName="payment-sepaip-popover"
            arrowColor={PALETTE.secondaryActive}
            content={
              <div>
                <p style={{ whiteSpace: 'pre-line' }}>
                  {messages["app.payments.sepaip.popover.txt"]
                    .split(/(\*\*[^*]+\*\*)/g)
                    .map((part, i) =>
                      part.startsWith('**') && part.endsWith('**')
                        ? <b key={i}>{part.slice(2, -2)}</b>
                        : part
                    )}
                </p>
              </div>}
          >
            <Info2 className="dashboard-total-mkt-val-Qmark" color={PALETTE.fordGray} height={32} width={32}/>
          </Popover>}

          {this.getSEPAIPStatusMsg()}
          
      </div>
    )
  }

  saveTemplateView = () => {
    const {
      app: { config: { isSepaIPEnabled } },
      i18n: { messages },
      payments: { isSaveEnabled, paymentType },
    } = this.props;
    const isLuxSepaIPAllowed = isSepaIPEnabled && envConfig.envConfig === EBANKINGWEBLUX;
    return (
      <View style={styles.templateView}>
        <View style={styles.checkBoxView}>
          <Checkbox
            onChange={() => this.handleCheck()}
            className="margin-right-10"
            checked={isSaveEnabled} 
            aria-label={messages['app.payment.templates.saveCheckbox.title']}
            label={messages['app.payment.templates.saveCheckbox.title']}
            />
          {paymentType?.includes('sepa') && isLuxSepaIPAllowed && this.renderSepaIPUI()}
            
          {/* <Text secondary>{messages['app.payment.templates.saveCheckbox.title']}</Text> */}
        </View>
        {isSaveEnabled &&
          <View style={styles.templateContainer}>
            <div aria-label={messages['app.payment.enterTemplateName']} className='margin-bottom-8'> 
            <Text secondary className='marginBottom0' tabIndex={0}>{messages['app.payment.templates.templateName']}</Text>
            </div>
            <div className='input-container'> 
              <TextInput
                onChange={(event) => this.handleTemplateName(event)}
                className="templateName"
                maxLength={35}
                value={this.state.currentTemplateName}
                aria-label={messages['app.payment.enterTemplateName']}
              />
            </div>
            
         </View>}
      </View>
    );
  }
 
  onModifyTemplate = () => {
    this.setState({ warnModifiedTemplate: false })
    this.props.payments.setSaveModifiedTemplate(true);
    this.props.payments.validatePayment();
    this.props.changePage(TX_SUMMARY);
  }
 
  onNoModifyTemplate = () => {
    this.setState({ warnModifiedTemplate: false })
    this.props.payments.validatePayment();
    // todo: route depends on dwoMessages
    this.props.changePage(TX_SUMMARY);
  }
  
  /* To display warning popup for template modified */
  renderConfirmationModal = () => {
    const { i18n: { messages } } = this.props;
    return (
      <Modal
        isActive={this.state.warnModifiedTemplate}
        style={styles.modalstyle}
        onClose={() => this.setState({ warnModifiedTemplate: false })}
        header={messages['app.warning.text']}
        className={"model-window-login"}
        content={
          <div className="padding-20">
            <div className="small-12 row">
              <div className="column small-1">
              <WarningIcon width={WARNING_ICON.width} height={WARNING_ICON.height} color={PALETTE.warning}/>
              </div>
              <div className="column small-11 padding-left-10 warningPaymentTemplate" tabIndex={0}>
                <Text>{messages['app.payment.templates.modified.template']}</Text>
              </div>
            </div>
            <div className="text-right margin-top-20">
              <Button
                tertiary
                onPress={this.onNoModifyTemplate}
                size="large">
                {messages['app.common.alert.no']}
              </Button>
              <Button
                onPress={this.onModifyTemplate}
                size="large"
              >
                {messages['app.common.alert.yes']}
              </Button>
            </div>
          </div>
        }
      />)
  }
 
  render() {
    const {
      changePage,
      app: { config: { isSepaIPEnabled } },
      i18n: { messages },
      payments: {
        selectedDebitAcnt,
        selectedBeneficiaryBank,
        selectedBeneficiaryDetail,
        isModifyFlow,
        errorMsgs,
        selectedCreditAcnt,
        amount,
        paymentType,
        toggleConfirmModal,
        setToggleConfirmModal,
        modifyTitle,
        isPaymentTemplateFlow,
        isSaveEnabled,
        selectedPaymentTemplate,
        remarks,
        sepaCountryBicIsoCodeList,
        paymentReason,
        selectedBeneficiaryBankSEPAPaymentType,
      },
      sepaLimit: { sepaTransactionLimit },
    } = this.props;

     // WMCE-42144 DWO LUX - International Payment to PSD2-country w/o BEN charging option
     /*Start*/
    const  newSwiftCode =  selectedBeneficiaryBank && selectedBeneficiaryBank.swiftCode && selectedBeneficiaryBank.swiftCode.slice(4,6);
    const  isSwiftCodePresent = sepaCountryBicIsoCodeList && sepaCountryBicIsoCodeList.includes(newSwiftCode);
    /*End*/
    const isInternal = paymentType.includes('internal')
    let pageTitle = messages['app.payment.pageTitle.newDomestic']
    if (isModifyFlow) {
      pageTitle = modifyTitle;
    } else if (isInternal) {
      pageTitle = messages['app.payment.pageTitle.newInternal'];
    } else if (paymentType.includes('international')) {
      pageTitle = messages['app.payment.pageTitle.newInternational'];
    } else if (paymentType.includes("sepa")) {
      pageTitle = messages['app.payment.pageTitle.newSepa'];
    }
    const isUKRegion = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK);
    const isLuxSepaIPAllowed = isSepaIPEnabled && envConfig.envConfig === EBANKINGWEBLUX;
 
    const templateValidation = isSaveEnabled ? this.state.currentTemplateName : (!isPaymentTemplateFlow || (isPaymentTemplateFlow && this.state.currentTemplateName));
    const { isNegativeAmount, isZeroAmount, isSepaLimitMissing, isSepaLimitExceeded } = getInstantSepaAmountValidation({
      paymentType,
      selectedBeneficiaryBankSEPAPaymentType,
      amount,
      sepaTransactionLimit,
      sepaPaymentType: SEPA_PAYMENT_TYPE,
      isSepaIPAllowed: isLuxSepaIPAllowed,
    });

    const enableValidation = !isNegativeAmount && !isZeroAmount && !isSepaLimitMissing && !isSepaLimitExceeded && ((selectedBeneficiaryBank || selectedBeneficiaryDetail) || selectedCreditAcnt) && amount && selectedDebitAcnt && templateValidation && (isUKRegion ? (!isEmpty(remarks) && paymentReason) :  (!isEmpty(remarks) ||isEmpty(remarks)) );

    return (
      <div className="payment-page row">
        {errorMsgs && <PaymentError errors={errorMsgs} />}
        <span className="title" id="title_domesticPayment_paymentForm_test">
          <H1 primary tabIndex={0}>{pageTitle}</H1>
        </span>
        {isPaymentTemplateFlow &&
          <View style={styles.row} accessible={true}>
            <Text secondary size="big" style={StyleSheet.flatten(styles.templateHeader)}>{messages['app.payment.templates.fromTemplate']}</Text>
            <Text className='margin-left-10' size="big" style={StyleSheet.flatten(styles.templateHeader)}>{selectedPaymentTemplate.templateName}</Text>
          </View>
        }
        <div className='form-bottom'>
          <View style={{ flex: 1, flexDirection: 'row' }}>
 
            <View style={{ flex: 1 }}>
              {/* EDIT HERE FOR INTERNAL */}
              {this.renderToAccount(isInternal ? selectedCreditAcnt : (selectedBeneficiaryBank || selectedBeneficiaryDetail ), messages, isInternal, paymentType)}
            </View>
            <View style={{ flex: 1, marginLeft: 10 }}>
              {/* {selectedDebitAcnt && */}
              {this.renderFromAccount(selectedDebitAcnt, messages, isInternal)}
            </View>
          </View>
          <div className="columns amntSection">
            <View style={{ flex: 1, flexDirection: 'row' }}>
              <View style={{ flex: 1, paddingTop: 10 }}>
                <PymtAmtDetails />
                <PymtDetails isSwiftCodePresent={isSwiftCodePresent}/>
              </View>
              {this.saveTemplateView()}
            </View>
          </div>
          <div align="right" className="resetButtonMargin">
            <Button testID="btn_domesticPayment_paymentForm_test"
              disabled={!enableValidation}
              onClick={enableValidation ? this.onValidateClick : () => { }}
              size="large"
            >
              {messages['app.common.payment.validatepymt']}
            </Button>
          </div>
        </div>
        {this.state.warnModifiedTemplate && this.renderConfirmationModal()}
        {toggleConfirmModal &&
          <FormBackConfirmModal
            messages={messages}
            onConfirm={(e) => this.confirmFormBackConfirm(e)}
            onClose={() => setToggleConfirmModal(false)}
            isModifyFlow={isModifyFlow} />
            }
      </div>
    );
  }
}
 
export default createContainer({
  $renderLoading: () => <LoadingCircle />,
  $queries: {
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
        },
      },
      config: {
        isSepaIPEnabled: true,
      },
    },
    auth: {
      addBeneficiaryDisabled: true
    },
    i18n: { messages: true },
    changePage: { $call: 'ui.history.push' },
    portfolio: {
      setAssetClassName: { $set: 'assetClassName' }
    },
    payments: {
      isCashFlow: true,
      isCashPaymentFlow: true,
      setIsCashPaymentFlow: { $set: 'isCashPaymentFlow' },
      isModifyFlow: true,
      setDisableTabs: { $set: 'disableTabs'},
      getTemplateList: { $call: 'getTemplateList' },
      templateList: true,
      isPaymentTemplateFlow: true,
      setErrorMsgs: { $set: 'errorMsgs' },
      templateName: true,
      setTemplateName: { $set: 'templateName' },
      selectedDebitAcnt: true,
      paymentReason: true,
      setSelectedDebitAcnt: { $set: 'selectedDebitAcnt' },
      selectedBeneficiaryBank: true,
      selectedBeneficiaryBankSEPAPaymentType: true,
      modifyTitle: true,
      currentTx: true,
      setBeneficiaryIdToUpdate: { $set: 'beneficiaryIdToUpdate'},
      setExistingBeneficiaryId: { $set: 'existingBeneficiaryId'},
      setIsPymtEditBenef: { $set: 'isPymtEditBenef'},
      validatePayment: { $call: 'validatePayment' },
      errorMsgs: true,
      paymentType: true,
      amount: true,
      loadCreditAccountList: { $call: 'loadCreditAccountList' },
      loadDebitAccountList: { $call: 'loadDebitAccountList' },
      selectedCreditAcnt: true,
      setSelectedCreditAcnt: { $set: 'selectedCreditAcnt' },
      toggleConfirmModal: true,
      setToggleConfirmModal: { $set: 'toggleConfirmModal' },
      isPymtAddNewBenef: true,
      setIsPymtAddNewBenef: { $set: 'isPymtAddNewBenef' },
      setModifyDebitAcntFlag: { $set: 'isModifyDebitAcnt' },
      isPymtEditFrmCaptureScreen: true,
      setDebitAccountFlow: { $set : 'setDebitAccountFlow' },
      setPaymentEditCapture: { $set: 'isPymtEditFrmCaptureScreen' },
      setSelectedBeneficiaryBank: { $set: 'selectedBeneficiaryBank' },
      setSelectedBeneficiaryBankSEPAPaymentType: { $set: 'selectedBeneficiaryBankSEPAPaymentType' },
      setIBAN: { $set: 'isIBANSelected' },
      setSelectedBeneficiaryDetail: { $set: 'selectedBeneficiaryDetail' },
      selectedBeneficiaryDetail: true,
      selectedPaymentTemplate: true,
      selectedCurrency: true,
      selectedCost: true,
      remarks: true,
      setSaveModifiedTemplate: { $set: 'saveModifiedTemplate' },
      isSaveEnabled: true,
      toggleSave: { $set: 'isSaveEnabled' },
      saveTemp: { $call: 'saveUpdateTemplate' },
      setSelectedPaymentTemplate: { $set: 'selectedPaymentTemplate' },
      sepaCountryBicIsoCodeList: true
    },
    sepaLimit: {
      sepaTransactionLimit: true,
    },
  },
})(PaymentForm);